module.exports = "/_next/static/videos/videoInstruction-554bdd0c6c3da042b2cd9d22b7f9fce4.mp4";